import script from "./Explain.vue?vue&type=script&setup=true&lang=js"
export * from "./Explain.vue?vue&type=script&setup=true&lang=js"

import "./Explain.vue?vue&type=style&index=0&id=13d280d1&scoped=true&lang=css"

import exportComponent from "/Users/henry/ionic/verbalchess_ionic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13d280d1"]])

export default __exports__